import React from "react";
import Fieldset from "../../common/Fieldset";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ValidationMessage from "../../common/ValidationMessage";
import * as types from "../../../constants/ComponentConstants";
import Tooltip from "../../common/Tooltip";
import classnames from "classnames";

const InitiatievenFormItem = (props) => {
    const { onChange, model, errors } = props;
    const hasError = !!props.errors["initiatieven"];

    const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
    const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";


    const checkClassName = {
        "c-input": true,
        "radiobuttonlist": true,
        "error": hasError
    };


    const validation = props.errors["initiatieven"] ? <ValidationMessage message={props.errors["initiatieven"]} /> : null;
    const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} isInput /> : null;


    const checkboxes = props.initiatievenList.map((item, i) =>
        <div key={"initiatieven" + i} className="c-input__group">
            <input type="checkbox" name="initiatieven" onChange={onChange}
                value={item.value} id={"initiatieven" + i} checked={model.initiatieven.includes(item.value)}/>
            <label htmlFor={"initiatieven" + i}>{item.label}</label>
            <br />
        </div>);

    return (
        <Fieldset title="Kies één of meer initiatieven uit onderstaande lijst">
            <div className={classnames(sizeClassName)}>
                <div className={classnames(checkClassName)}>
                    <div className="c-input__field">{checkboxes}</div>
                    {info}
                </div>
                {validation}
            </div>
        </Fieldset>
    );
};



InitiatievenFormItem.propTypes = {
    size: PropTypes.number,
    tooltip: PropTypes.string,
    tooltipType: PropTypes.string,
    onChange: PropTypes.func,
    model: PropTypes.object,
    initiatievenList: PropTypes.array,
    errors: PropTypes.array
};

function mapStateToProps(state, ownProps) {
    return {
        initiatievenList: state.referentie.initiatieven
    };
}

export default connect(mapStateToProps)(InitiatievenFormItem);